import { useRef } from 'react';
import { t, Trans } from '@lingui/macro';
import { Tabs, Tab, Button } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import AdminPage from '../AdminPage';
import { AdminPages, buildPageId } from '../AdminLinkUtils';
import Actions from '../../page-framework/actions/Actions';
import { useNavigate } from '../../../utilities/PgmUtilities';
import GeneralTab from './GeneralTab';
import InterfaceSelectionTab from './InterfaceSelectionTab';
import AccessPointSelectionTab from './AccessPointSelectionTab';
import { TAB_GENERAL, TAB_IFACE_SEL, TAB_AP_SEL, POLLING_TABS } from './PollingConstants';

const functionName = AdminPages.Polling;

export const VALID_TABS = POLLING_TABS;
export const DEFAULT_TAB = TAB_GENERAL;

export default function PollingAdminPage() {
    const { tab } = useParams();
    const navigate = useNavigate();
    const pollingRef = useRef(null);
    const interfaceRef = useRef(null);
    const accessRef = useRef(null);

    const handleTabChange = (event, newTab) => {
        navigate(`../${newTab}`);
    };

    const onSave = async () => {
        switch (tab) {
            case TAB_GENERAL:
                await pollingRef.current?.save();
                break;
            case TAB_IFACE_SEL:
                await interfaceRef.current?.save();
                break;
            case TAB_AP_SEL:
                await accessRef.current?.save();
                break;
            default:
                break;
        }
    };

    return (
        <AdminPage
            title={t`Polling Configuration`}
            pageId={buildPageId(functionName)}
            actions={
                <Actions>
                    <Button onClick={onSave} variant="contained" color="primary">
                        <Trans>Save</Trans>
                    </Button>
                </Actions>
            }
        >
            <>
                <Tabs value={tab} onChange={handleTabChange}>
                    <Tab label={t`GENERAL`} value={TAB_GENERAL} />
                    <Tab label={t`INTERFACE SELECTION`} value={TAB_IFACE_SEL} />
                    <Tab label={t`ACCESS POINT SELECTION`} value={TAB_AP_SEL} />
                </Tabs>
                {tab === TAB_GENERAL && <GeneralTab ref={pollingRef} />}
                {tab === TAB_IFACE_SEL && <InterfaceSelectionTab ref={interfaceRef} />}
                {tab === TAB_AP_SEL && <AccessPointSelectionTab ref={accessRef} />}
            </>
        </AdminPage>
    );
}
